var React = require('react');

function Mozio (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"fill":"#418AC9","fillRule":"nonzero","d":"M20.81 27.524c5.923 0 10.7-4.725 10.7-10.524 0-5.799-4.777-10.524-10.7-10.524-5.924 0-10.702 4.725-10.702 10.524 0 5.799 4.778 10.524 10.702 10.524zm0 6.476c-9.495 0-17.191-7.611-17.191-17s7.696-17 17.19-17C30.305 0 38 7.611 38 17s-7.696 17-17.19 17z","key":0}),React.createElement("path",{"fill":"#FBC013","d":"M22.619 17L0 31.316V2.684z","key":1})]));
}

Mozio.defaultProps = {"width":"38","height":"34","viewBox":"0 0 38 34"};

module.exports = Mozio;

Mozio.default = Mozio;
